import {$glVars} from './common';

const i18n = $glVars.i18n;
i18n.setLang("fr");
i18n.addTag("appName", "RÉCIT Work Plan", "Plan de travail RÉCIT");
i18n.addTag("search", "Search", "Rechercher");
i18n.addTag("msgConfirmArchive", "Are you sure you want to archive this?", "Confirmez-vous l'archivage?");
i18n.addTag("msgConfirmUnArchive", "Are you sure you want to unarchive this?", "Confirmez-vous le désarchivage?");
i18n.addTag("msgConfirmDeletion", "Do you confirm the deletion?", "Confirmez-vous la suppression? Cette opération est irréversible.");
i18n.addTag("msgConfirm", "Are you sure you want to proceed?", "Êtes-vous sur de vouloir continuer?");
i18n.addTag("msgConfirmClone", "Are you sure you want to clone this?", "Êtes-vous sur de vouloir dupliquer ce gabarit?");
i18n.addTag("msgSuccess", "The action has been completed successfully.", "L'action a été complétée avec succès.");
i18n.addTag("displayType", "Display Type", "Type d'affichage");
i18n.addTag("tab", "Tab", "Onglet");
i18n.addTag("toc", "Table of Contents", "Table de Matières");
i18n.addTag("pagination", "Pagination", "Pagination");
i18n.addTag("name", "Name", "Nom");
i18n.addTag("msgRemovePage", "This action will erase all the user's data and it is irreversible.", "Cette action effacera toutes les données de l'utilisateur et elle est irréversible.");
i18n.addTag("nbViews", "Nb Views", "Nb. Vues");
i18n.addTag("lastUpdate", "Last Update", "Dernière mise à jour");
i18n.addTag("firstView", "First View", "Première visualisation");
i18n.addTag("lastView", "Last View", "Dernière visualisation");
i18n.addTag("grade", "Grade", "Grade");
i18n.addTag("preview", "Preview", "Aperçu");
i18n.loadTags();
